import React from 'react';
export const RightArrowIcon = () => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6018 6L13.1295 7.80314L15.5162 10.7245H5.5407C4.96623 10.7245 4.5 11.2956 4.5 11.9992C4.5 12.7027 4.96623 13.2738 5.5407 13.2738H15.5162L13.1295 16.1969L14.6018 18L19.5 11.9992L14.6018 6Z",
    fill: "currentColor"
  }));
};